<template>
  <div class="empty-container">
    <img src="../../assets/images/empty.png" alt="" class="empty-img" />
  </div>
</template>

<script>
export default {
  name: "Empty",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.empty-container {
  text-align: center;
  padding: 100px;
  .empty-img {
    width: 180px;
  }
}
</style>
